import { connectCurrentRefinements } from 'instantsearch.js/es/connectors'
import { excludedAttributesForCurrentRefinements } from '../../utils/search/filters'
import { withoutLandingScopeCategoryRefinements } from '../../utils/search/categoryPaths'

const renderActiveFilterCount = (renderOptions) => {
  const { items } = renderOptions

  // Count total refinements across all items
  const totalCount = items.reduce((total, item) => total + item.refinements.length, 0)

  // Update the UI with the count
  const activeFiltersElement = document.getElementById('vjs-active-filters-count')
  if (activeFiltersElement) {
    if (totalCount > 0) {
      activeFiltersElement.textContent = `(${totalCount})`
      activeFiltersElement.classList.remove('hidden')
    } else {
      activeFiltersElement.textContent = ''
      activeFiltersElement.classList.add('hidden')
    }
  }
}

const customActiveFilterCount = connectCurrentRefinements(renderActiveFilterCount)

const activeFilterCountWidget = () => {
  return customActiveFilterCount({
    excludedAttributes: excludedAttributesForCurrentRefinements(),
    // the landing scope refinement represents the page itself, not an applied filter
    transformItems: withoutLandingScopeCategoryRefinements
  })
}

export { activeFilterCountWidget }
